import React from "react"
import PropTypes from 'prop-types'

import SelectGenericNew from "../../../../gd-ui/select-generic-new/select-generic-new"
import {
    VALIDATION_CHANGED, VALIDATION_EMPTY,
    VALIDATION_EXCLUDES,
    VALIDATION_INCLUDES, VALIDATION_LABELS,
    VALIDATION_NOT_EMPTY
} from "../../../../model2/automation/constants/custom-field-validation";
import FieldDropdown_PopoverOptionUser from "../../dropdown/components/option/option-user";
import FieldUser_FormValueNotEmpty from "../../user/components/form/value-not-empty";
import {FieldAutomationTriggerFormProps} from "../../../render/automation-trigger-form";

const options = _.map([
    VALIDATION_CHANGED,
    VALIDATION_NOT_EMPTY,
    VALIDATION_EMPTY,
    VALIDATION_INCLUDES,
    VALIDATION_EXCLUDES,
], value=>({
    value: value,
    label: _.get(VALIDATION_LABELS, value)
}))

const debug = false
// const debug = "UsersTriggerForm"

export default class FieldUsers_AutomationTriggerForm extends React.Component<FieldAutomationTriggerFormProps, any> {

    static propTypes = {
        config          : PropTypes.object,

        options         : PropTypes.array,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:FieldAutomationTriggerFormProps) {
        super(props)

        this.state = {
            validationType  : _.get(props.config, 'validationType', VALIDATION_CHANGED),
            value           : _.get(props.config, 'value', null),
        }
    }

    onChangeValidationType = (option:any) => {
        const validationType = option.value

        this.setState({
            validationType
        }, ()=>{
            this.props.onChangeCallback({validationType})
        })
    }

    onChangeValue = (option:any) => {
        const value = option.value

        this.setState({
            value
        }, ()=>{
            this.props.onChangeCallback({value})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        return (
            <React.Fragment>
                <div className="flex-row-left-center">
                    <div className="label w-100">Trigger when</div>
                    <SelectGenericNew className                     = "selector w-180"
                                      options                       = {options}
                                      value                         = {this.state.validationType}
                                      popoverScrollContainerClasses = "max-h-200 max-w-200"
                                      disabled                      = {this.props.config.disabled}
                                      onChange                      = {this.onChangeValidationType}/>
                </div>
                {[VALIDATION_INCLUDES, VALIDATION_EXCLUDES].includes(this.state.validationType) &&
                    <div className="flex-row-left-center m-t-10">
                        <div className="label w-100"/>
                        <SelectGenericNew className                     = "selector w-180"
                                          options                       = {this.props.field.getAutomationOptions()}
                                          value                         = {this.state.value}
                                          popoverScrollContainerClasses = "max-h-200"
                                          valueComponent                = {FieldUser_FormValueNotEmpty}
                                          popoverOptionComponent        = {FieldDropdown_PopoverOptionUser}
                                          disabled                      = {this.props.config.disabled}
                                          onChange                      = {this.onChangeValue}/>
                    </div>}
            </React.Fragment>
        )
    }
}